module.exports = __webpack_public_path__ + "media/como-chegar.bcf0ee63.mp4";